import src from "IMAGE";
export default { src, width: 1440, height: 1265, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
